/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileMasterclass } from '../../models/file-masterclass';
import { FileUrl } from '../../models/file-url';

export interface ApiFileMasterclassUrlPost$Params {
      body: FileMasterclass
}

export function apiFileMasterclassUrlPost(http: HttpClient, rootUrl: string, params: ApiFileMasterclassUrlPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUrl>> {
  const rb = new RequestBuilder(rootUrl, apiFileMasterclassUrlPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FileUrl>;
    })
  );
}

apiFileMasterclassUrlPost.PATH = '/api/file/masterclass-url';
